import { render, staticRenderFns } from "./WikiImageBulkUpload.vue?vue&type=template&id=19127632"
import script from "./WikiImageBulkUpload.vue?vue&type=script&lang=ts"
export * from "./WikiImageBulkUpload.vue?vue&type=script&lang=ts"
import style0 from "./WikiImageBulkUpload.vue?vue&type=style&index=0&id=19127632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports